/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Announcements_Aria_LabelInputs */

const fr_announcements_aria_label = /** @type {(inputs: Announcements_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualités`)
};

const en_announcements_aria_label = /** @type {(inputs: Announcements_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`News`)
};

/**
* | output |
* | --- |
* | "News" |
*
* @param {Announcements_Aria_LabelInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const announcements_aria_label = /** @type {((inputs?: Announcements_Aria_LabelInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Announcements_Aria_LabelInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_announcements_aria_label(inputs)
	return en_announcements_aria_label(inputs)
});